// extracted by mini-css-extract-plugin
export default {"settings-switch-field":"fd5957","settings-switch-field__content":"d0af90","settings-switch-field__label":"f0650b","settings-switch-field__hint":"ff156c"};